var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 282,
    width: 47,
    height: 230,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511,
    y: 374,
    width: 47,
    height: 230,
    rx: 12,
    transform: "rotate(90 511 374)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 0C28.6538 0 0 28.6538 0 64V167C0 202.346 28.6538 231 64 231H167C202.346 231 231 202.346 231 167V64C231 28.6538 202.346 0 167 0H64ZM62 46C53.1634 46 46 53.1634 46 62V169C46 177.837 53.1634 185 62 185H169C177.837 185 185 177.837 185 169V62C185 53.1634 177.837 46 169 46H62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 0C309.654 0 281 28.6538 281 64V167C281 202.346 309.654 231 345 231H448C483.346 231 512 202.346 512 167V64C512 28.6538 483.346 0 448 0H345ZM343 46C334.163 46 327 53.1634 327 62V169C327 177.837 334.163 185 343 185H450C458.837 185 466 177.837 466 169V62C466 53.1634 458.837 46 450 46H343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 281C28.6538 281 0 309.654 0 345V448C0 483.346 28.6538 512 64 512H167C202.346 512 231 483.346 231 448V345C231 309.654 202.346 281 167 281H64ZM62 327C53.1634 327 46 334.163 46 343V450C46 458.837 53.1634 466 62 466H169C177.837 466 185 458.837 185 450V343C185 334.163 177.837 327 169 327H62Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.0fd390420fbdda5abc7c312cc85c2d2b.svg";
export { ForwardRef as ReactComponent };